import { render, staticRenderFns } from "./BtActionsSelector.vue?vue&type=template&id=366ec124&"
import script from "./BtActionsSelector.vue?vue&type=script&lang=js&"
export * from "./BtActionsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports